var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.isOpen } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("load-rows-from-csv")))]),
          _vm.page == 1
            ? [
                _c(
                  "w-card-content",
                  [
                    _c(
                      "w-row",
                      [
                        _c("w-col", { attrs: { xs: "12" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("load-rows-from-csv-info", {
                                  allowedFields: _vm.allowedFields,
                                })
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("app-file-upload", {
                              attrs: {
                                "allowed-extensions": _vm.allowedExtensions,
                                label: _vm.$ct("drop-your-csv-file-here"),
                              },
                              on: {
                                input: function ($event) {
                                  _vm.file = $event
                                },
                              },
                            }),
                            _vm.file
                              ? _c("span", { staticClass: "file-name" }, [
                                  _vm._v(_vm._s(_vm.file.name)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("w-checkbox", {
                              attrs: {
                                label: _vm.$ct(
                                  "use-comma-as-decimal-seperator"
                                ),
                              },
                              model: {
                                value: _vm.options.useCommaAsDeciamlSeperator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.options,
                                    "useCommaAsDeciamlSeperator",
                                    $$v
                                  )
                                },
                                expression:
                                  "options.useCommaAsDeciamlSeperator",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-card-actions",
                  [
                    _c(
                      "w-button",
                      {
                        staticClass: "cancel",
                        attrs: { icon: "ban" },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                    ),
                    _c("w-spacer"),
                    _c(
                      "w-button",
                      {
                        attrs: { disabled: !_vm.file, icon: "check" },
                        on: {
                          click: function ($event) {
                            return _vm.confirm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                    ),
                  ],
                  1
                ),
              ]
            : _vm.page == 2
            ? _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    { attrs: { center: "" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", center: "" } },
                        [_c("w-progress-circular")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }